import React from "react";
import SaasProductWizard from "../index";

function ESETWizard() {
  return <SaasProductWizard productType="eset" />;
}

export default ESETWizard;